import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';
import 'rxjs/add/operator/map';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class ApiService {

  private apiUrl = 'https://graterenowa.nysa.eu/api/';

  constructor(private http: HttpClient, public configurationService: ConfigurationService) { }

  public getObjectsTrip(tripId, lang = this.configurationService.data.language) {
    return this.http.get(this.apiUrl + `objects/trip/${tripId}/${lang}`);
  }

  public getTripData(tripId, lang = this.configurationService.data.language) {
    return this.http.get(this.apiUrl + `trips/${tripId}/${lang}`);
  }

  public getRandQuestion(objectId, lang = this.configurationService.data.language) {
    return this.http.get(this.apiUrl + `questions/rand/${objectId}/${lang}`);
  }

  public getCheckAnswer(questionId, answerId, lang = this.configurationService.data.language) {
    return this.http.get(this.apiUrl + `questions/check/${questionId}/${answerId}/${lang}`);
  }

  public getQuestion(questionId, lang = this.configurationService.data.language) {
    return this.http.get(this.apiUrl + `questions/${questionId}/${lang}`);
  }

  public checkAnswer(questionId, answerId, lang = this.configurationService.data.language) {
    return this.http.get(this.apiUrl + `questions/check/${questionId}/${answerId}/${lang}`);
  }

  public getRankData(rankType, tripId) {
    return this.http.get(this.apiUrl + `scores/rank/${rankType}/${tripId}/10`);
  }
  public getRankDataAllDevices(tripId) {
    return this.http.get(this.apiUrl + `scores/rank/${tripId}/99999`);
  }

  public saveScore(mobile, name, score, tripId) {
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    let body = new HttpParams();
    body = body.set('mobile', mobile);
    body = body.set('name', name);
    body = body.set('score', score);
    body = body.set('trip_id', tripId);
    return this.http.post(this.apiUrl + `scores`, body, { headers: headers });
  }

  private extractData(res: Response) {
    const body = res.json();
    return body || {};
  }

}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/services/api.service.ts